<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">数据字典</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('168')"
        >添加</el-button
      >
    </ul>
    <div class="tree-box" style="margin-top: 10px">
      <div class="tree-box-tree">
        <ul>
          <li class="dictionary-list-tree-title">字典类别</li>
          <el-button
            link
            title="刷新"
            size="small"
            :class="state.cateData ? '' : 'refresh-rotate'"
            @click="onLoadCate"
          >
            <template #icon>
              <el-icon style="font-weight: 600" color="#a2a2a2" :size="16"
                ><Refresh
              /></el-icon>
            </template>
          </el-button>
        </ul>
        <div style="overflow-y: auto; padding-right: 5px">
          <el-radio-group
            v-model="state.params.dictionary_cate_id"
            class="dictionary-cate-group"
            @change="onLoad()"
            style="width: 100%"
          >
            <el-radio
              :value="null"
              size="large"
              style="width: 100%; margin: 0; border-radius: 0"
              border
              >全部</el-radio
            >
            <el-radio
              v-for="item in state.cateData"
              :key="item"
              :value="item.id"
              size="large"
              style="
                width: 100%;
                margin: 0;
                border-radius: 0;
                border-top-width: 0;
              "
              border
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="tree-box-content">
        <ul class="tree-box-content-search">
          <el-space wrap style="flex: 1">
            <el-input
              v-model="state.params.name"
              style="width: 200px"
              placeholder="--关键字--"
              clearable
              @clear="
                delete state.params.name;
                onLoad();
              "
            ></el-input>
            <el-dropdown split-button @click="onLoad" type="primary">
              查询
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                    重置
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-space>
        </ul>
        <div class="tree-box-content-table">
          <el-table
            :data="state.tableData"
            v-loading="!Array.isArray(state.tableData)"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            :default-sort="{
              prop: state.params.sort_field,
              order:
                state.params.sort_value == 'desc' ? 'descending' : 'ascending',
            }"
            row-key="id"
            default-expand-all
            @sort-change="onSortChange"
          >
            <el-table-column
              prop="name"
              sortable="name"
              label="名称"
              :formatter="
                (row, column, cellValue) =>
                  $tab_Highlinght(cellValue, state.params.name)
              "
              min-width="220"
              show-overflow-tooltip
            />
            <el-table-column
              prop="description"
              sortable="description"
              label="说明"
              :formatter="$tab_TextFormat"
              min-width="260"
              show-overflow-tooltip
            />
            <el-table-column
              label="状态"
              prop="status"
              sortable="status"
              width="100"
            >
              <template #default="{ row }">
                <el-switch
                  v-model="row.status"
                  inline-prompt
                  active-text="启用"
                  active-color="#1e90ff"
                  inactive-text="停用"
                  inactive-color="#f00"
                  :active-value="1"
                  :inactive-value="0"
                  style="--el-switch-off-color: #f00"
                  @change="onChangeQt(row)"
                  :disabled="!$judge_auth('171')"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              sortable="create_time"
              label="创建时间"
              width="180"
            />
            <el-table-column
              prop="update_time"
              sortable="update_time"
              label="修改时间"
              width="180"
            />
            <el-table-column
              label="操作"
              width="160"
              align="center"
              fixed="right"
              className="tabBtn"
              v-if="$judge_auth(['169', '170'])"
            >
              <template #default="{ row }">
                <el-button
                  type="primary"
                  link
                  icon="Edit"
                  @click="
                    state.selectId = row.id;
                    state.showInfo = true;
                  "
                  v-if="$judge_auth('169')"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  link
                  icon="Delete"
                  @click="onDelete(row.id)"
                  v-if="$judge_auth('170')"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <c_page
            :total="state.totalCount"
            :pageIndex="state.params.page"
            :pageSize="state.params.limit"
            @onLoad="
              (page) => {
                state.params.page = page.pageIndex;
                state.params.limit = page.pageSize;
                onLoad();
              }
            "
          />
        </div>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '字典'"
        @close="state.showInfo = false"
      >
        <c_DictionaryInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :cateId="state.params.dictionary_cate_id"
          :id="state.selectId"
        ></c_DictionaryInfo>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  dictionarycate_list,
  dictionary_list,
  dictionary_delete,
  dictionary_qt,
} from "@/http/api";
import { ElMessageBox, ElMessage } from "element-plus";
import { confirm_func } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCate();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      dictionary_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onLoadCate = () => {
      delete state.cateData;
      dictionarycate_list().then((res) => {
        if (res.status == 200) state.cateData = res.data.data.list;
      });
    };

    const onCateClick = (row) => {
      state.params.dictionary_cate_id = row.id;
      state.params.page = 1;
      onLoad();
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //启停
    const onChangeQt = (row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 0
            ? '<strong style="color:#f00">停用'
            : '<strong style="color:#1e90ff">启用'
        }</strong>该数据字典吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          dictionary_qt(row).then((res) => {
            if (res.status == 200)
              ElMessage({
                type: "success",
                grouping: true,
                message: res.data.msg,
              });
          });
        })
        .catch(() => {
          row.status = row.status == 1 ? 0 : 1;
        });
    };

    //删除
    const onDelete = (id) => {
      confirm_func(dictionary_delete, id, onLoad);
    };

    return {
      state,
      onLoadCate,
      onCateClick,
      onLoad,
      onSortChange,
      onReset,
      onChangeQt,
      onDelete,
    };
  },
};
</script>
<style scoped lang="less">
.dictionary-list-tree-title {
  position: relative;
  padding-left: 7px;
  font-size: 13px;
  color: #a2a2a2;
  flex: 1;
  &::after {
    content: "";
    width: 3px;
    background-color: #1e90ff;
    border-radius: 10px;
    height: 70%;
    top: 15%;
    position: absolute;
    left: 0;
  }
}

.refresh-rotate {
  animation: fadenum 2s linear infinite;
}

@keyframes fadenum {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.dictionary-cate-group {
  .is-checked {
    border-top-width: 1px !important;
  }
}
</style>
